import { render, staticRenderFns } from "./MyDormGaleriCover.vue?vue&type=template&id=df11a84a&"
import script from "./MyDormGaleriCover.vue?vue&type=script&lang=js&"
export * from "./MyDormGaleriCover.vue?vue&type=script&lang=js&"
import style0 from "./MyDormGaleriCover.vue?vue&type=style&index=0&id=df11a84a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports